import React from 'react';
import DateInfoDisplay from '../components/DateInfoDisplay';

const DateTest = () => {
  return (
    <div>
      <DateInfoDisplay />
    </div>
  );
};

export default DateTest;

